// Кнопка экспорта результатов в DOCX

import { Download } from 'lucide-react';
import { Button } from './Button';
import { exportToDocx } from '../../utils/docxGenerator';
import type { CalculationInput, VoltageLossResult, HeatingResult } from '../../types';

interface ExportButtonProps {
  mode: 'voltage' | 'heating';
  input: CalculationInput;
  voltageLossResult?: VoltageLossResult | null;
  heatingResult?: HeatingResult | null;
  disabled?: boolean;
}

export function ExportButton({
  mode,
  input,
  voltageLossResult,
  heatingResult,
  disabled = false,
}: ExportButtonProps) {
  const handleExport = async () => {
    try {
      await exportToDocx(mode, input, voltageLossResult, heatingResult);
    } catch (error) {
      console.error('Ошибка при экспорте:', error);
      alert('Не удалось создать документ. Проверьте, что расчёт выполнен.');
    }
  };

  // Кнопка неактивна, если нет результатов
  const isDisabled = disabled || 
    (mode === 'voltage' && !voltageLossResult) ||
    (mode === 'heating' && !heatingResult);

  return (
    <Button
      variant="success"
      onClick={handleExport}
      disabled={isDisabled}
      icon={<Download size={18} />}
    >
      Экспорт в DOCX
    </Button>
  );
}
